import { Component, OnInit } from '@angular/core';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { translate } from '@jsverse/transloco';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from 'src/app/models/constants';
import {Router} from '@angular/router';
import { FormUtilService } from 'src/app/services/util/form-util.service';



@Component({
    selector: 'app-isb-package',
    templateUrl: './isb-package.component.html',
    styleUrls: ['./isb-package.component.scss'],
    standalone: false
})
export class IsbPackageComponent implements OnInit {

  breadcrumbItems: BreadcrumbItem[] = [];
  tenant: string;
  title: string;
  createIsbForm: FormGroup;
  constants = Constants;
  lsbSolutionOptions: any;
  isbSolutionVersionOption: any;
  typeOption: any;
  providerOption: any;
  dbOption: any;
  mediaForm: FormGroup[] = [];

  constructor(private authService: AuthService, public sidenavService: SidenavService, private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {
    this.createForm();
    this.title = translate('LINE_OF_BUSINESS.ADD_NEW_LOB');
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS';
    this.tenant = this.authService.principal.provider;
    this.breadcrumbItems.push({ icon: 'assets/images/home_icon.svg' },
      { label: translate('LEFT_SIDE_NAV.VIEW_REQUEST') },
      { label: translate('LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS'),url: ['isb'] },
      { label: translate('ISB.CREATE_PACKAGE') });
    this.lsbSolutionOptions = [
      { value: 'Retail Servicing', selected: false },
      { value: 'Retail Deposits', selected: false },
      { value: 'Retail Deposits', selected: false }
    ];

    this.isbSolutionVersionOption = [
      { value: '1.0.0', selected: false },
      { value: '2.0.0', selected: false },
      { value: '3.0.0', selected: false }
    ];

    this.typeOption = [
      { value: 'cloud', selected: 'false' },
      { value: 'on Premise', selected: 'false' }
    ];

    this.providerOption = [
      { value: 'Azure', selected: 'false' },
      { value: 'AWS', selected: 'false' },
      { value: 'Google cloud', selected: 'false' }
    ];

    this.dbOption = [
      { value: 'sql', selected: 'false' },
      { value: 'Mongo', selected: 'false' },
      { value: 'oracle', selected: 'false' }

    ];
  }

  isbPage(): void {
    this.router.navigate(['/',this.authService.principal.provider, 'isb']);
  }

  createForm(): void {
    const formConfig: any = {
      buildSolution: [undefined, [Validators.required]],
      buildVersion: [undefined, [Validators.required]],
      type: [undefined, [Validators.required]],
      provider: [undefined, [Validators.required]],
      dbtype: [undefined, [Validators.required]]
    };
    this.createIsbForm = this.formBuilder.group(formConfig);
  }

  getDeployment(): any {
    let failed = false;
    if (!FormUtilService.validateForm(this.createIsbForm)) {
      return;
    }
    this.mediaForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    if (failed) {
      return;
    } else {
      return this.createIsbForm.getRawValue();
    }
  }

  createIsb(): void {
    if (!this.getDeployment()) {
      return;
    }
    let mediaList = [];
    this.mediaForm.forEach(media => {
      mediaList = [...mediaList, media.getRawValue()];
    });
    const obj = this.getDeployment();
    obj.media = mediaList;
    this.sidenavService.closeRightSidenav(obj);
  }

  cancelbtn(): void {
    this.createIsbForm.reset();
  }
}
